export default __webpack_public_path__ + "static/media/get-it-on-google-play.6577102c.svg";